export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("page:finish", async () => {
    window.scrollTo({ top: 0 })
    document.querySelector(".v-main__scroller")?.scrollTo({ top: 0 })
  })
})
